import React from 'react';
import PropTypes from 'prop-types';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { Tile } from 'web-ui-components/lib/molecules/tile';

function NoPreviousCOPTile({
  confirmationOfPayeeContent: {
    noPreviousCheckHeader,
    noPreviousCheckDescription,
    noPreviousCheckButton,
  },
  showAddPayeePage,
}) {
  return (
    <Tile isBordered align="left" className="col-lg1-12 col-md1-12 col-sm1-24">
      <h4>{noPreviousCheckHeader}</h4>
      <StandardBody>
        <span>{noPreviousCheckDescription}</span>
      </StandardBody>
      <div>
        <NavigationButton.Primary
          labelText={noPreviousCheckButton}
          onClick={showAddPayeePage}
          data-test-id="no-previous-cop-check-now-button"
        />
      </div>
    </Tile>
  );
}

NoPreviousCOPTile.propTypes = {
  confirmationOfPayeeContent: PropTypes.shape({
    noPreviousCheckHeader: PropTypes.string.isRequired,
    noPreviousCheckDescription: PropTypes.string.isRequired,
    noPreviousCheckButton: PropTypes.string.isRequired,
  }).isRequired,
  showAddPayeePage: PropTypes.func.isRequired,
};

export { NoPreviousCOPTile };
